import React from "react";
import styled from "styled-components";
import { colors } from "../../Shared/colors";
import { NavLink } from "react-router-dom";
import ManageAccountsIcon from "@mui/icons-material/ManageAccounts";
import AccountCircleIcon from "@mui/icons-material/AccountCircle";
import { name } from "../../Shared/config";
import { decryptData } from "../../services/crypto";
import { Section } from "./sharedSidebarStyles";

export const StaffSidebar = () => {
  let role = null;
  let storedStaffRole = localStorage.getItem("role");

  if (storedStaffRole) {
    try {
      role = decryptData(storedStaffRole);
    } catch (error) {
      console.error("Failed to decrypt data:", error);
    }
  }

  return (
    <>
      <Section>
        <p>Staff</p>
        <div>
          <NavLink end to="staff">
            <AccountCircleIcon />
            <span>{name} Contact</span>
          </NavLink>
          <>
            {role !== "ts" && (
              <NavLink end to="staff/manageStaff">
                <ManageAccountsIcon /> <span>Manage Staff</span>
              </NavLink>
            )}
            {role !== "ts" && (
              <NavLink ent to="staff/manageTeamHerarchy">
                <ManageAccountsIcon /> <span>Team Hierarchy</span>
              </NavLink>
            )}
          </>
          {/* ) : null} */}
          {role !== "ts" && (
            <NavLink end to="staff/manageTeam">
              <ManageAccountsIcon /> <span>Manage Team</span>
            </NavLink>
          )}
        </div>
      </Section>
    </>
  );
};

// Styled components are now imported from sharedSidebarStyles.js
